import styled from 'styled-components';

// O `BimSpatialTree` mede o `clientHeight` do PAI para dimensionar a lista
// virtual do antd — sem altura em px ele calcula zero e não desenha linha
// nenhuma. Dentro da lista de modelos não existe altura definida para herdar
// (cada modelo é um item de altura automática), então a âncora é aqui.
//
// Altura fixa e não `vh`: a árvore convive com outros modelos na mesma lista, e
// quem rola é a lista de modelos. Uma árvore que crescesse com o conteúdo
// empurraria os modelos seguintes para fora da vista.
export const IfcTreeWrapper = styled.div`
  height: 260px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
